export default "__VITE_ASSET__C7qzw80b__"